import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Download, Trash2 } from "lucide-react";
import { api } from "@/lib/api";

// Perfil → Privacidad: solo aparece si el usuario tiene datos de salud guardados de antes de la suspensión.
export const DatosSaludGuardados = () => {
  const [n, setN] = useState(null);
  const [confirmar, setConfirmar] = useState(false);
  const [aviso, setAviso] = useState("");
  useEffect(() => { api.get("/salud/datos/resumen").then((r) => setN(r.data.total)).catch(() => setN(0)); }, []);
  if (!n && !aviso) return null;
  const descargar = async () => {
    try {
      const { data } = await api.get("/salud/datos/exportar");
      const a = Object.assign(document.createElement("a"), { href: URL.createObjectURL(new Blob([JSON.stringify(data, null, 2)], { type: "application/json" })), download: "al-dia-mis-datos-de-salud.json" });
      a.click(); URL.revokeObjectURL(a.href);
    } catch { toast.error("No se pudieron descargar tus datos."); }
  };
  const eliminar = async () => {
    try {
      const { data } = await api.delete("/salud/datos");
      setN(0); setConfirmar(false);
      setAviso(data.archivos_no_eliminables
        ? `Hemos eliminado tus datos de salud. ${data.archivos_no_eliminables} archivo(s) original(es) ya no son accesibles desde AL DÍA, pero el almacenamiento anterior no permite borrarlos físicamente; seguimos gestionándolo con el proveedor.`
        : "Hemos eliminado tus datos de salud.");
    } catch { toast.error("No se pudieron eliminar los datos de salud."); }
  };
  return (
    <div className="mt-5 pt-5 border-t border-[#E5DFD5]" data-testid="datos-salud-guardados">
      <h3 className="font-semibold text-[#1C2421]">Datos de Salud guardados</h3>
      {aviso ? <p className="text-sm text-[#4A5550] mt-2" data-testid="datos-salud-aviso">{aviso}</p> : (
        <>
          <p className="text-sm text-[#6E7A74] mt-1">Tienes datos de salud guardados de antes de la fase de prueba. No se muestran en la app.</p>
          <div className="flex flex-wrap gap-2 mt-3">
            <button data-testid="datos-salud-descargar" onClick={descargar} className="inline-flex items-center gap-1.5 min-h-[44px] px-4 rounded-xl border border-[#E5DFD5] font-semibold"><Download size={18} /> Descargar mis datos de Salud</button>
            <button data-testid="datos-salud-eliminar" onClick={() => setConfirmar(true)} className="inline-flex items-center gap-1.5 min-h-[44px] px-4 rounded-xl border border-[#FECACA] text-[#B91C1C] font-semibold"><Trash2 size={18} /> Eliminar mis datos de Salud</button>
          </div>
          {confirmar && (
            <div className="mt-3 bg-[#FEF2F2] border border-[#FECACA] rounded-xl p-4" data-testid="datos-salud-confirmar">
              <p className="text-base">Se eliminarán de AL DÍA Fácil tus datos y referencias de Salud y dejarán de estar accesibles desde tu cuenta. Algunos archivos originales antiguos pueden permanecer almacenados temporalmente en la infraestructura de nuestro proveedor hasta que podamos completar su eliminación técnica.</p>
              <div className="flex gap-2 mt-3">
                <button data-testid="datos-salud-confirmar-si" onClick={eliminar} className="flex-1 min-h-[44px] rounded-xl bg-[#B91C1C] text-white font-semibold">Sí, eliminar</button>
                <button data-testid="datos-salud-confirmar-no" onClick={() => setConfirmar(false)} className="flex-1 min-h-[44px] rounded-xl border border-[#E5DFD5] bg-white font-semibold">Cancelar</button>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};
